var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 2.9L18 2.1C16.6 0.7 14.8 0 13 0C11.2 0 9.4 0.7 8 2.1L8.8 2.9C10 1.8 11.5 1.2 13 1.2C14.5 1.2 16 1.8 17.2 2.9ZM16.3 3.7C15.4 2.8 14.2 2.3 13 2.3C11.8 2.3 10.6 2.8 9.7 3.7L10.5 4.5C11.2 3.8 12.1 3.5 13 3.5C13.9 3.5 14.8 3.8 15.5 4.5L16.3 3.7ZM16 10H14V6H12V10H2C0.9 10 0 10.9 0 12V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V12C18 10.9 17.1 10 16 10ZM5 15H3V13H5V15ZM8.5 15H6.5V13H8.5V15ZM12 15H10V13H12V15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModem);
export default __webpack_public_path__ + "static/media/modem.b6247c9b.svg";
export { ForwardRef as ReactComponent };